import React from 'react';
import { Select } from 'antd';
import styled from 'styled-components';
import Widget from '../../../widget';
import { selectFilterSearch } from '../../../../../helpers/StringHelper';
import { getPopupContainer } from '../../../../../helpers/popUp';

const Style = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  flex: 1;

  .children {
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }

  .legend-cont {
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
    gap: 10px;

    &.is-grid {
      display: grid;
      grid-template-columns: 1fr 1fr;
      width: fit-content;
      margin-left: auto;
      margin-right: auto;
    }

    .item {
      display: flex;
      gap: 4px;     
      cursor: pointer;
      transition: .4s opacity;

      &.disabled { 
        opacity: 0.5;
      }

      label {
        margin-bottom: 0px;
        cursor: pointer;
        font-size: 12px;
        font-weight: 500;
        whitespace: nobreak;
      }
    }
    
    .cont {
      display: flex;
      flex-direction: column;
      justify-content: center;
    }

    .legend {
      width: 8px;
      height: 8px;
      margin-right: 4px;
      border-radius: 100%;
    }
  }

  .filters {
    display: flex;
    flex-direction: column;
    gap: 12px;

    .cont {
      display: flex;
      flex-direction: column;
      justify-content: center;

      label {
        margin-bottom: 0px;
        color: #001529;
        font-weight: 600;
        width: 70px;
      }

      .legend {
        width: 12px;
        height: 12px;
        margin-right: 4px;
        border-radius: 100%;
      }
    }

    .ant-select {
      min-width: 100px;
    }

    .item {
      display: flex;

      .ant-select {
        margin-left: 38px;
        flex: 1;
        max-width: calc(100% - 110px);
      }
    }
  }
`;

const PeriodWidget = ({
  children,
  title = null,
  className = null,
  loading = false,
  header = null,
  filtersConfig = [],
}) => {
  return (
    <Widget
      title={title}
      className={className}
      loading={loading}
      header={header}
    >
      <Style>
        <div className="children">
          {children}
        </div>
        {filtersConfig.length ? (
          <div className="filters">
            {filtersConfig.map((f) => (
              <div className="item" key={`filters-${f.key}`}>
                <div className="cont">
                  {f.legend && (
                    <div className="legend" style={{ background: f.legend }} />
                  )}
                </div>
                <div className="cont">
                  <label>{f.label}</label>
                </div>
                <Select
                  {...getPopupContainer()}
                  defaultValue={f.defaultValue}
                  onChange={(val) => typeof f.onChange === 'function' ? f.onChange(val) : {}}
                  showSearch
                  filterOption={selectFilterSearch}
                >
                  {f.options.map((o) => Array.isArray(o.children) ? (
                    <Select.OptGroup key={o.value} label={o.label}>
                      {o.children.map((ch) => (
                        <Select.Option
                          key={`filters-${f.key}-${ch.value}`}
                          value={ch.value}
                        >
                          {ch.label}
                        </Select.Option>
                      ))}
                    </Select.OptGroup>
                  ) : (
                    <Select.Option
                      key={`filters-${f.key}-${o.value}`}
                      value={o.value}
                    >
                      {o.label}
                    </Select.Option>
                  ))}
                </Select>
              </div>
            ))}
          </div>
        ) : null}
      </Style>
    </Widget>
  )
};

export default PeriodWidget;
